// extracted by mini-css-extract-plugin
export var borderRadius = "_a3-4";
export var large = "_a3-3";
export var logoContainer = "_a3-0";
export var nameLogo = "_a3-2";
export var small = "_a3-1";